import React from 'react';
import { Card, Col, Row, Typography, Space } from 'antd';
import { DollarOutlined } from '@ant-design/icons';
import './Card.css';

const { Title, Text } = Typography;

const StaticCard = ({
  cardColor = '#C484F3',
  textColor = 'white',
  iconColor = 'white',
  title = "Sales",
  amount = "$25,970",
  time = "Last 24 hours",
  icon = <DollarOutlined />,
}) => {
  return (
    <Card
      className="static-card"
      style={{ '--card-color': cardColor }}
    >
      <Row justify="space-between" align="middle">
      <Text className="static-title" style={{ '--text-color': textColor, fontSize: '2 em' }}>{title}</Text>
      <span className="static-icon" style={{ '--icon-color': iconColor}}>{icon}</span>
      </Row>
      <Row justify="space-between" align="middle">
      <Title level={3} className="static-amount" style={{ '--text-color': textColor }}>{amount}</Title>
      <Text className="static-time" style={{ '--text-color': textColor }}>{time}</Text>
      </Row>
    </Card>
  );
};

export default StaticCard;